import type {StateProvider} from '@uirouter/angularjs';
import UtilController, {decorateLoggersWithState} from './util.controller';
import type ServerStateDataService from './server-state.data-service';
import type LoggerDataService from './logger.data-service';
import type UtilsDataService from './utils.data-service';

/*@ngInject*/
export default function utilRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state({
            name: 'util',
            url: '/util',
            templateUrl: require('./util.tpl.ftl'),
            controller: UtilController,
            controllerAs: 'utilCtrl',
            resolve: {
                state: /*@ngInject*/ (serverStateDataService: ServerStateDataService) => serverStateDataService.getServerState(),
                loggers: /*@ngInject*/ (loggerDataService: LoggerDataService) => loggerDataService.getLoggers().then(decorateLoggersWithState),
                activeClientSessions: /*@ngInject*/ (utilsDataService: UtilsDataService) => utilsDataService.getActiveClientSessionsList()
            }
        });
}
